unit View.Bancos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils;

type
  TFViewBancosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo: TLabel;
    edcodigo: TDBEdit;
    lbdigital: TLabel;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientBancosGet: TXDataWebClient;
    BancosDataset: TXDataWebDataSet;
    BancosDatasetid: TIntegerField;
    BancosDatasetnome: TStringField;
    BancosDatasetcodigo: TStringField;
    BancosDatasetdigital: TBooleanField;
    BancosDatasetcodigo_interno: TIntegerField;
    BancosDatasetexcluido: TBooleanField;
    BancosDatasetinclusao: TDateTimeField;
    BancosDatasetalteracao: TDateTimeField;
    BancosDatasetexclusao: TDateTimeField;
    lbcodigo_cliente: TLabel;
    edcodigo_cliente: TDBEdit;
    lbtoken: TLabel;
    edtoken: TDBEdit;
    lbultima_sinc_ws: TLabel;
    edultima_sinc_ws: TDBEdit;
    lbconsulta_sinc_ws: TLabel;
    edconsulta_sinc_ws: TDBEdit;
    BancosDatasetcodigo_cliente: TIntegerField;
    BancosDatasettoken: TStringField;
    BancosDatasetultima_sinc_ws: TDateTimeField;
    BancosDatasetconsulta_sinc_ws: TDateTimeField;
    cbxexcluido: TDBCheckBox;
    cbxdigital: TDBCheckBox;
    btnCopiarToken: TButton;
    pnlDadosBanco: TPanel;
    pnlDadosSincronizacaoAutomatica: TPanel;
    lbsinc_aut_id: TLabel;
    edsinc_aut_id: TDBEdit;
    lbsinc_aut_codigo_interno: TLabel;
    edsinc_aut_codigo_interno: TDBEdit;
    lbclient_id: TLabel;
    edclient_id: TDBEdit;
    edclient_secret: TDBEdit;
    lbclient_secret: TLabel;
    eddeveloper_key: TDBEdit;
    lbdeveloper_key: TLabel;
    lbsinc_aut_excluido: TLabel;
    cbxsinc_aut_excluido: TDBCheckBox;
    lbsinc_aut_inclusao: TLabel;
    edsinc_aut_inclusao: TDBEdit;
    lbsinc_aut_alteracao: TLabel;
    edsinc_aut_alteracao: TDBEdit;
    edsinc_aut_exclusao: TDBEdit;
    lbsinc_aut_exclusao: TLabel;
    btnBaixarChavePrivada: TButton;
    btnBaixarCertificadoPem: TButton;
    BancosDatasetbanco_sinccodigo_interno: TIntegerField;
    BancosDatasetbanco_sincclient_id: TStringField;
    BancosDatasetbanco_sincclient_secret: TStringField;
    BancosDatasetbanco_sincdeveloper_key: TStringField;
    BancosDatasetbanco_sincid: TIntegerField;
    BancosDatasetbanco_sincexcluido: TBooleanField;
    BancosDatasetbanco_sincinclusao: TDateTimeField;
    BancosDatasetbanco_sincalteracao: TDateTimeField;
    BancosDatasetbanco_sincexclusao: TDateTimeField;
    BancosDatasetbanco_sincchave_privada_s3: TStringField;
    BancosDatasetbanco_sinccertificado_pem_s3: TStringField;
    XDataWebClientBaixarArquivos: TXDataWebClient;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientBancosGetLoad(Response: TXDataClientResponse);
    procedure BancosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnCopiarTokenClick(Sender: TObject);
    procedure btnBaixarChavePrivadaClick(Sender: TObject);
    procedure btnBaixarCertificadoPemClick(Sender: TObject);
    procedure XDataWebClientBaixarArquivosError(Error: TXDataClientError);
    procedure XDataWebClientBaixarArquivosLoad(Response: TXDataClientResponse);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure BaixarArquivoPem(pChavePrivada : Boolean);
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewBancosEdit: TFViewBancosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewBancosEdit }

class function TFViewBancosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewBancosEdit.InsertEntity;
begin
  BancosDataset.Close;
  BancosDataset.SetJsonData('{}');
  BancosDataset.Open;
  BancosDataset.Insert;
end;

class function TFViewBancosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewBancosEdit(AForm).FInserting := AInserting;
    TFViewBancosEdit(AForm).FId := AId;
    TFViewBancosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewBancosEdit(AForm).InsertEntity
    else
      TFViewBancosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewBancosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewBancosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    BancosDataset.Connection.Model.DefaultSchema.FindEntityType(
      BancosDataset.EntitySetName
    )
  );
  XDataClientBancosGet.Get(BancosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewBancosEdit.XDataClientBancosGetLoad(Response: TXDataClientResponse);
begin
  BancosDataset.Close;
  BancosDataset.SetJsonData(Response.Result);
  BancosDataset.Open;
  
  BancosDataset.Edit;

  if edtoken.Text = EmptyStr then
    btnCopiarToken.Enabled := False;

  if edsinc_aut_id.Text = EmptyStr then
  begin
    TUtils.RemoverElementoPorId('line-sinc_aut-tab');
    TUtils.RemoverElementoPorId('line-sinc_aut');
  end;
end;

procedure TFViewBancosEdit.XDataWebClientBaixarArquivosError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewBancosEdit.XDataWebClientBaixarArquivosLoad(
  Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewBancosEdit.BaixarArquivoPem(pChavePrivada: Boolean);
var
  lJson : TJSObject;
begin
  TUtils.ChamarDivLoading;

  lJson := TJSObject.New;

  if pChavePrivada then
    lJson['tipo'] := 'chave_privada'
  else
    lJson['tipo'] := 'certificado_pem';

  lJson['codigo'] := edsinc_aut_id.Text;
  lJson['tabela'] := 'bancos_sinc_aut';

  XDataWebClientBaixarArquivos.RawInvoke('IService.BaixarArquivo', [lJson]);
end;

procedure TFViewBancosEdit.BancosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewBancosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewBancosEdit.btnBaixarCertificadoPemClick(Sender: TObject);
begin
  BaixarArquivoPem(False);
end;

procedure TFViewBancosEdit.btnBaixarChavePrivadaClick(Sender: TObject);
begin
  BaixarArquivoPem(True);
end;

procedure TFViewBancosEdit.btnCopiarTokenClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Token copiado com sucesso!', 'Cópia de token',
    edtoken.Text);
end;

procedure TFViewBancosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.bancos.form.lbid');
  lbnome := TLabel.Create('view.bancos.form.lbnome');
  lbcodigo := TLabel.Create('view.bancos.form.lbcodigo');
  lbdigital := TLabel.Create('view.bancos.form.lbdigital');
  lbcodigo_interno := TLabel.Create('view.bancos.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.bancos.form.lbexcluido');
  lbinclusao := TLabel.Create('view.bancos.form.lbinclusao');
  lbalteracao := TLabel.Create('view.bancos.form.lbalteracao');
  lbexclusao := TLabel.Create('view.bancos.form.lbexclusao');
  lbcodigo_cliente := TLabel.Create('view.bancos.form.lbcodigo_cliente');
  lbtoken := TLabel.Create('view.bancos.form.lbtoken');
  lbultima_sinc_ws := TLabel.Create('view.bancos.form.lbultima_sinc_ws');
  lbconsulta_sinc_ws := TLabel.Create('view.bancos.form.lbconsulta_sinc_ws');
  lbsinc_aut_id := TLabel.Create('view.bancos.form.lbsinc_aut_id');
  lbsinc_aut_codigo_interno := TLabel.Create('view.bancos.form.lbsinc_aut_codigo_interno');
  lbclient_id := TLabel.Create('view.bancos.form.lbclient_id');
  lbclient_secret := TLabel.Create('view.bancos.form.lbclient_secret');
  lbdeveloper_key := TLabel.Create('view.bancos.form.lbdeveloper_key');
  lbsinc_aut_excluido := TLabel.Create('view.bancos.form.lbsinc_aut_excluido');
  lbsinc_aut_inclusao := TLabel.Create('view.bancos.form.lbsinc_aut_inclusao');
  lbsinc_aut_alteracao := TLabel.Create('view.bancos.form.lbsinc_aut_alteracao');
  lbsinc_aut_exclusao := TLabel.Create('view.bancos.form.lbsinc_aut_exclusao');
  btCancel := TButton.Create('view.bancos.form.btBack');
  edid := TDBEdit.Create('view.bancos.form.edid');
  ednome := TDBEdit.Create('view.bancos.form.ednome');
  edcodigo := TDBEdit.Create('view.bancos.form.edcodigo');
  edcodigo_interno := TDBEdit.Create('view.bancos.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.bancos.form.edinclusao');
  edalteracao := TDBEdit.Create('view.bancos.form.edalteracao');
  edexclusao := TDBEdit.Create('view.bancos.form.edexclusao');
  edcodigo_cliente := TDBEdit.Create('view.bancos.form.edcodigo_cliente');
  edtoken := TDBEdit.Create('view.bancos.form.edtoken');
  edultima_sinc_ws := TDBEdit.Create('view.bancos.form.edultima_sinc_ws');
  edconsulta_sinc_ws := TDBEdit.Create('view.bancos.form.edconsulta_sinc_ws');
  cbxexcluido := TDBCheckBox.Create('view.bancos.form.cbxexcluido');
  cbxdigital := TDBCheckBox.Create('view.bancos.form.cbxdigital');
  btnCopiarToken := TButton.Create('btnCopiarToken');
  pnlDadosBanco := TPanel.Create(Self);
  pnlDadosSincronizacaoAutomatica := TPanel.Create(Self);
  edsinc_aut_id := TDBEdit.Create('view.bancos.form.edsinc_aut_id');
  edsinc_aut_codigo_interno := TDBEdit.Create('view.bancos.form.edsinc_aut_codigo_interno');
  edclient_id := TDBEdit.Create('view.bancos.form.edclient_id');
  edclient_secret := TDBEdit.Create('view.bancos.form.edclient_secret');
  eddeveloper_key := TDBEdit.Create('view.bancos.form.eddeveloper_key');
  cbxsinc_aut_excluido := TDBCheckBox.Create('view.bancos.form.cbxsinc_aut_excluido');
  edsinc_aut_inclusao := TDBEdit.Create('view.bancos.form.edsinc_aut_inclusao');
  edsinc_aut_alteracao := TDBEdit.Create('view.bancos.form.edsinc_aut_alteracao');
  edsinc_aut_exclusao := TDBEdit.Create('view.bancos.form.edsinc_aut_exclusao');
  btnBaixarChavePrivada := TButton.Create('btnBaixarChavePrivada');
  btnBaixarCertificadoPem := TButton.Create('btnBaixarCertificadoPem');
  DataSource := TDataSource.Create(Self);
  BancosDataset := TXDataWebDataSet.Create(Self);
  BancosDatasetid := TIntegerField.Create(Self);
  BancosDatasetnome := TStringField.Create(Self);
  BancosDatasetcodigo := TStringField.Create(Self);
  BancosDatasetdigital := TBooleanField.Create(Self);
  BancosDatasetcodigo_interno := TIntegerField.Create(Self);
  BancosDatasetexcluido := TBooleanField.Create(Self);
  BancosDatasetinclusao := TDateTimeField.Create(Self);
  BancosDatasetalteracao := TDateTimeField.Create(Self);
  BancosDatasetexclusao := TDateTimeField.Create(Self);
  BancosDatasetcodigo_cliente := TIntegerField.Create(Self);
  BancosDatasettoken := TStringField.Create(Self);
  BancosDatasetultima_sinc_ws := TDateTimeField.Create(Self);
  BancosDatasetconsulta_sinc_ws := TDateTimeField.Create(Self);
  BancosDatasetbanco_sinccodigo_interno := TIntegerField.Create(Self);
  BancosDatasetbanco_sincclient_id := TStringField.Create(Self);
  BancosDatasetbanco_sincclient_secret := TStringField.Create(Self);
  BancosDatasetbanco_sincdeveloper_key := TStringField.Create(Self);
  BancosDatasetbanco_sincid := TIntegerField.Create(Self);
  BancosDatasetbanco_sincexcluido := TBooleanField.Create(Self);
  BancosDatasetbanco_sincinclusao := TDateTimeField.Create(Self);
  BancosDatasetbanco_sincalteracao := TDateTimeField.Create(Self);
  BancosDatasetbanco_sincexclusao := TDateTimeField.Create(Self);
  BancosDatasetbanco_sincchave_privada_s3 := TStringField.Create(Self);
  BancosDatasetbanco_sinccertificado_pem_s3 := TStringField.Create(Self);
  XDataClientBancosGet := TXDataWebClient.Create(Self);
  XDataWebClientBaixarArquivos := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbcodigo.BeforeLoadDFMValues;
  lbdigital.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbcodigo_cliente.BeforeLoadDFMValues;
  lbtoken.BeforeLoadDFMValues;
  lbultima_sinc_ws.BeforeLoadDFMValues;
  lbconsulta_sinc_ws.BeforeLoadDFMValues;
  lbsinc_aut_id.BeforeLoadDFMValues;
  lbsinc_aut_codigo_interno.BeforeLoadDFMValues;
  lbclient_id.BeforeLoadDFMValues;
  lbclient_secret.BeforeLoadDFMValues;
  lbdeveloper_key.BeforeLoadDFMValues;
  lbsinc_aut_excluido.BeforeLoadDFMValues;
  lbsinc_aut_inclusao.BeforeLoadDFMValues;
  lbsinc_aut_alteracao.BeforeLoadDFMValues;
  lbsinc_aut_exclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edcodigo.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  edcodigo_cliente.BeforeLoadDFMValues;
  edtoken.BeforeLoadDFMValues;
  edultima_sinc_ws.BeforeLoadDFMValues;
  edconsulta_sinc_ws.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxdigital.BeforeLoadDFMValues;
  btnCopiarToken.BeforeLoadDFMValues;
  pnlDadosBanco.BeforeLoadDFMValues;
  pnlDadosSincronizacaoAutomatica.BeforeLoadDFMValues;
  edsinc_aut_id.BeforeLoadDFMValues;
  edsinc_aut_codigo_interno.BeforeLoadDFMValues;
  edclient_id.BeforeLoadDFMValues;
  edclient_secret.BeforeLoadDFMValues;
  eddeveloper_key.BeforeLoadDFMValues;
  cbxsinc_aut_excluido.BeforeLoadDFMValues;
  edsinc_aut_inclusao.BeforeLoadDFMValues;
  edsinc_aut_alteracao.BeforeLoadDFMValues;
  edsinc_aut_exclusao.BeforeLoadDFMValues;
  btnBaixarChavePrivada.BeforeLoadDFMValues;
  btnBaixarCertificadoPem.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  BancosDataset.BeforeLoadDFMValues;
  BancosDatasetid.BeforeLoadDFMValues;
  BancosDatasetnome.BeforeLoadDFMValues;
  BancosDatasetcodigo.BeforeLoadDFMValues;
  BancosDatasetdigital.BeforeLoadDFMValues;
  BancosDatasetcodigo_interno.BeforeLoadDFMValues;
  BancosDatasetexcluido.BeforeLoadDFMValues;
  BancosDatasetinclusao.BeforeLoadDFMValues;
  BancosDatasetalteracao.BeforeLoadDFMValues;
  BancosDatasetexclusao.BeforeLoadDFMValues;
  BancosDatasetcodigo_cliente.BeforeLoadDFMValues;
  BancosDatasettoken.BeforeLoadDFMValues;
  BancosDatasetultima_sinc_ws.BeforeLoadDFMValues;
  BancosDatasetconsulta_sinc_ws.BeforeLoadDFMValues;
  BancosDatasetbanco_sinccodigo_interno.BeforeLoadDFMValues;
  BancosDatasetbanco_sincclient_id.BeforeLoadDFMValues;
  BancosDatasetbanco_sincclient_secret.BeforeLoadDFMValues;
  BancosDatasetbanco_sincdeveloper_key.BeforeLoadDFMValues;
  BancosDatasetbanco_sincid.BeforeLoadDFMValues;
  BancosDatasetbanco_sincexcluido.BeforeLoadDFMValues;
  BancosDatasetbanco_sincinclusao.BeforeLoadDFMValues;
  BancosDatasetbanco_sincalteracao.BeforeLoadDFMValues;
  BancosDatasetbanco_sincexclusao.BeforeLoadDFMValues;
  BancosDatasetbanco_sincchave_privada_s3.BeforeLoadDFMValues;
  BancosDatasetbanco_sinccertificado_pem_s3.BeforeLoadDFMValues;
  XDataClientBancosGet.BeforeLoadDFMValues;
  XDataWebClientBaixarArquivos.BeforeLoadDFMValues;
  try
    Name := 'FViewBancosEdit';
    Width := 514;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 24;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 8;
    lbnome.Top := 51;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbcodigo.SetParentComponent(Self);
    lbcodigo.Name := 'lbcodigo';
    lbcodigo.Left := 8;
    lbcodigo.Top := 78;
    lbcodigo.Width := 59;
    lbcodigo.Height := 13;
    lbcodigo.Caption := 'C'#243'd. Banco:';
    lbcodigo.HeightPercent := 100.000000000000000000;
    lbcodigo.WidthPercent := 100.000000000000000000;
    lbdigital.SetParentComponent(Self);
    lbdigital.Name := 'lbdigital';
    lbdigital.Left := 8;
    lbdigital.Top := 105;
    lbdigital.Width := 34;
    lbdigital.Height := 13;
    lbdigital.Caption := 'Digital?';
    lbdigital.HeightPercent := 100.000000000000000000;
    lbdigital.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 8;
    lbcodigo_interno.Top := 132;
    lbcodigo_interno.Width := 47;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 159;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 8;
    lbinclusao.Top := 186;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 232;
    lbalteracao.Top := 24;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 232;
    lbexclusao.Top := 51;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbcodigo_cliente.SetParentComponent(Self);
    lbcodigo_cliente.Name := 'lbcodigo_cliente';
    lbcodigo_cliente.Left := 232;
    lbcodigo_cliente.Top := 78;
    lbcodigo_cliente.Width := 63;
    lbcodigo_cliente.Height := 13;
    lbcodigo_cliente.Caption := 'C'#243'd. Cliente:';
    lbcodigo_cliente.HeightPercent := 100.000000000000000000;
    lbcodigo_cliente.WidthPercent := 100.000000000000000000;
    lbtoken.SetParentComponent(Self);
    lbtoken.Name := 'lbtoken';
    lbtoken.Left := 232;
    lbtoken.Top := 105;
    lbtoken.Width := 33;
    lbtoken.Height := 13;
    lbtoken.Caption := 'Token:';
    lbtoken.HeightPercent := 100.000000000000000000;
    lbtoken.WidthPercent := 100.000000000000000000;
    lbultima_sinc_ws.SetParentComponent(Self);
    lbultima_sinc_ws.Name := 'lbultima_sinc_ws';
    lbultima_sinc_ws.Left := 232;
    lbultima_sinc_ws.Top := 132;
    lbultima_sinc_ws.Width := 78;
    lbultima_sinc_ws.Height := 13;
    lbultima_sinc_ws.Caption := #218'ltima Sinc. WS:';
    lbultima_sinc_ws.HeightPercent := 100.000000000000000000;
    lbultima_sinc_ws.WidthPercent := 100.000000000000000000;
    lbconsulta_sinc_ws.SetParentComponent(Self);
    lbconsulta_sinc_ws.Name := 'lbconsulta_sinc_ws';
    lbconsulta_sinc_ws.Left := 232;
    lbconsulta_sinc_ws.Top := 159;
    lbconsulta_sinc_ws.Width := 91;
    lbconsulta_sinc_ws.Height := 13;
    lbconsulta_sinc_ws.Caption := 'Consulta Sinc. WS:';
    lbconsulta_sinc_ws.HeightPercent := 100.000000000000000000;
    lbconsulta_sinc_ws.WidthPercent := 100.000000000000000000;
    lbsinc_aut_id.SetParentComponent(Self);
    lbsinc_aut_id.Name := 'lbsinc_aut_id';
    lbsinc_aut_id.Left := 8;
    lbsinc_aut_id.Top := 288;
    lbsinc_aut_id.Width := 52;
    lbsinc_aut_id.Height := 13;
    lbsinc_aut_id.Caption := 'C'#243'd. Serv:';
    lbsinc_aut_id.HeightPercent := 100.000000000000000000;
    lbsinc_aut_id.WidthPercent := 100.000000000000000000;
    lbsinc_aut_codigo_interno.SetParentComponent(Self);
    lbsinc_aut_codigo_interno.Name := 'lbsinc_aut_codigo_interno';
    lbsinc_aut_codigo_interno.Left := 8;
    lbsinc_aut_codigo_interno.Top := 315;
    lbsinc_aut_codigo_interno.Width := 47;
    lbsinc_aut_codigo_interno.Height := 13;
    lbsinc_aut_codigo_interno.Caption := 'C'#243'd. Ret:';
    lbsinc_aut_codigo_interno.HeightPercent := 100.000000000000000000;
    lbsinc_aut_codigo_interno.WidthPercent := 100.000000000000000000;
    lbclient_id.SetParentComponent(Self);
    lbclient_id.Name := 'lbclient_id';
    lbclient_id.Left := 8;
    lbclient_id.Top := 342;
    lbclient_id.Width := 44;
    lbclient_id.Height := 13;
    lbclient_id.Caption := 'Client Id:';
    lbclient_id.HeightPercent := 100.000000000000000000;
    lbclient_id.WidthPercent := 100.000000000000000000;
    lbclient_secret.SetParentComponent(Self);
    lbclient_secret.Name := 'lbclient_secret';
    lbclient_secret.Left := 8;
    lbclient_secret.Top := 369;
    lbclient_secret.Width := 65;
    lbclient_secret.Height := 13;
    lbclient_secret.Caption := 'Client Secret:';
    lbclient_secret.HeightPercent := 100.000000000000000000;
    lbclient_secret.WidthPercent := 100.000000000000000000;
    lbdeveloper_key.SetParentComponent(Self);
    lbdeveloper_key.Name := 'lbdeveloper_key';
    lbdeveloper_key.Left := 8;
    lbdeveloper_key.Top := 396;
    lbdeveloper_key.Width := 74;
    lbdeveloper_key.Height := 13;
    lbdeveloper_key.Caption := 'Developer Key:';
    lbdeveloper_key.HeightPercent := 100.000000000000000000;
    lbdeveloper_key.WidthPercent := 100.000000000000000000;
    lbsinc_aut_excluido.SetParentComponent(Self);
    lbsinc_aut_excluido.Name := 'lbsinc_aut_excluido';
    lbsinc_aut_excluido.Left := 232;
    lbsinc_aut_excluido.Top := 288;
    lbsinc_aut_excluido.Width := 44;
    lbsinc_aut_excluido.Height := 13;
    lbsinc_aut_excluido.Caption := 'Exclu'#237'do?';
    lbsinc_aut_excluido.HeightPercent := 100.000000000000000000;
    lbsinc_aut_excluido.WidthPercent := 100.000000000000000000;
    lbsinc_aut_inclusao.SetParentComponent(Self);
    lbsinc_aut_inclusao.Name := 'lbsinc_aut_inclusao';
    lbsinc_aut_inclusao.Left := 232;
    lbsinc_aut_inclusao.Top := 315;
    lbsinc_aut_inclusao.Width := 44;
    lbsinc_aut_inclusao.Height := 13;
    lbsinc_aut_inclusao.Caption := 'Inclus'#227'o:';
    lbsinc_aut_inclusao.HeightPercent := 100.000000000000000000;
    lbsinc_aut_inclusao.WidthPercent := 100.000000000000000000;
    lbsinc_aut_alteracao.SetParentComponent(Self);
    lbsinc_aut_alteracao.Name := 'lbsinc_aut_alteracao';
    lbsinc_aut_alteracao.Left := 232;
    lbsinc_aut_alteracao.Top := 342;
    lbsinc_aut_alteracao.Width := 50;
    lbsinc_aut_alteracao.Height := 13;
    lbsinc_aut_alteracao.Caption := 'Altera'#231#227'o:';
    lbsinc_aut_alteracao.HeightPercent := 100.000000000000000000;
    lbsinc_aut_alteracao.WidthPercent := 100.000000000000000000;
    lbsinc_aut_exclusao.SetParentComponent(Self);
    lbsinc_aut_exclusao.Name := 'lbsinc_aut_exclusao';
    lbsinc_aut_exclusao.Left := 232;
    lbsinc_aut_exclusao.Top := 369;
    lbsinc_aut_exclusao.Width := 46;
    lbsinc_aut_exclusao.Height := 13;
    lbsinc_aut_exclusao.Caption := 'Exclus'#227'o:';
    lbsinc_aut_exclusao.HeightPercent := 100.000000000000000000;
    lbsinc_aut_exclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 232;
    btCancel.Top := 178;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 93;
    edid.Top := 21;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 93;
    ednome.Top := 48;
    ednome.Width := 120;
    ednome.Height := 21;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edcodigo.SetParentComponent(Self);
    edcodigo.Name := 'edcodigo';
    edcodigo.Left := 93;
    edcodigo.Top := 75;
    edcodigo.Width := 120;
    edcodigo.Height := 21;
    edcodigo.Enabled := False;
    edcodigo.HeightPercent := 100.000000000000000000;
    edcodigo.TabOrder := 10;
    edcodigo.Text := 'edcodigo';
    edcodigo.WidthPercent := 100.000000000000000000;
    edcodigo.DataField := 'codigo';
    edcodigo.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 93;
    edcodigo_interno.Top := 129;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 93;
    edinclusao.Top := 183;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 349;
    edalteracao.Top := 21;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 349;
    edexclusao.Top := 48;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    edcodigo_cliente.SetParentComponent(Self);
    edcodigo_cliente.Name := 'edcodigo_cliente';
    edcodigo_cliente.Left := 349;
    edcodigo_cliente.Top := 75;
    edcodigo_cliente.Width := 120;
    edcodigo_cliente.Height := 21;
    edcodigo_cliente.ChildOrder := 20;
    edcodigo_cliente.Enabled := False;
    edcodigo_cliente.HeightPercent := 100.000000000000000000;
    edcodigo_cliente.TabOrder := 12;
    edcodigo_cliente.Text := 'edcodigo_cliente';
    edcodigo_cliente.WidthPercent := 100.000000000000000000;
    edcodigo_cliente.DataField := 'codigo_cliente';
    edcodigo_cliente.DataSource := DataSource;
    edtoken.SetParentComponent(Self);
    edtoken.Name := 'edtoken';
    edtoken.Left := 349;
    edtoken.Top := 102;
    edtoken.Width := 120;
    edtoken.Height := 21;
    edtoken.ChildOrder := 22;
    edtoken.Enabled := False;
    edtoken.HeightPercent := 100.000000000000000000;
    edtoken.TabOrder := 12;
    edtoken.Text := 'edtoken';
    edtoken.WidthPercent := 100.000000000000000000;
    edtoken.DataField := 'token';
    edtoken.DataSource := DataSource;
    edultima_sinc_ws.SetParentComponent(Self);
    edultima_sinc_ws.Name := 'edultima_sinc_ws';
    edultima_sinc_ws.Left := 349;
    edultima_sinc_ws.Top := 129;
    edultima_sinc_ws.Width := 120;
    edultima_sinc_ws.Height := 21;
    edultima_sinc_ws.ChildOrder := 24;
    edultima_sinc_ws.Enabled := False;
    edultima_sinc_ws.HeightPercent := 100.000000000000000000;
    edultima_sinc_ws.TabOrder := 12;
    edultima_sinc_ws.Text := 'edultima_sinc_ws';
    edultima_sinc_ws.WidthPercent := 100.000000000000000000;
    edultima_sinc_ws.DataField := 'ultima_sinc_ws';
    edultima_sinc_ws.DataSource := DataSource;
    edconsulta_sinc_ws.SetParentComponent(Self);
    edconsulta_sinc_ws.Name := 'edconsulta_sinc_ws';
    edconsulta_sinc_ws.Left := 349;
    edconsulta_sinc_ws.Top := 156;
    edconsulta_sinc_ws.Width := 120;
    edconsulta_sinc_ws.Height := 21;
    edconsulta_sinc_ws.ChildOrder := 26;
    edconsulta_sinc_ws.Enabled := False;
    edconsulta_sinc_ws.HeightPercent := 100.000000000000000000;
    edconsulta_sinc_ws.TabOrder := 12;
    edconsulta_sinc_ws.Text := 'edconsulta_sinc_ws';
    edconsulta_sinc_ws.WidthPercent := 100.000000000000000000;
    edconsulta_sinc_ws.DataField := 'consulta_sinc_ws';
    edconsulta_sinc_ws.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 93;
    cbxexcluido.Top := 156;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxdigital.SetParentComponent(Self);
    cbxdigital.Name := 'cbxdigital';
    cbxdigital.Left := 93;
    cbxdigital.Top := 102;
    cbxdigital.Width := 120;
    cbxdigital.Height := 22;
    cbxdigital.Caption := 'cbxdigital';
    cbxdigital.ChildOrder := 33;
    cbxdigital.Enabled := False;
    cbxdigital.HeightPercent := 100.000000000000000000;
    cbxdigital.WidthPercent := 100.000000000000000000;
    cbxdigital.DataField := 'digital';
    cbxdigital.DataSource := DataSource;
    btnCopiarToken.SetParentComponent(Self);
    btnCopiarToken.Name := 'btnCopiarToken';
    btnCopiarToken.Left := 471;
    btnCopiarToken.Top := 102;
    btnCopiarToken.Width := 30;
    btnCopiarToken.Height := 21;
    btnCopiarToken.ChildOrder := 22;
    btnCopiarToken.HeightPercent := 100.000000000000000000;
    btnCopiarToken.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarToken, Self, 'OnClick', 'btnCopiarTokenClick');
    pnlDadosBanco.SetParentComponent(Self);
    pnlDadosBanco.Name := 'pnlDadosBanco';
    pnlDadosBanco.Left := 8;
    pnlDadosBanco.Top := 0;
    pnlDadosBanco.Width := 461;
    pnlDadosBanco.Height := 17;
    pnlDadosBanco.Caption := 'Espa'#231'o Dados Banco';
    pnlDadosBanco.ChildOrder := 23;
    pnlDadosBanco.Color := clInfoText;
    pnlDadosBanco.Font.Charset := DEFAULT_CHARSET;
    pnlDadosBanco.Font.Color := clWhite;
    pnlDadosBanco.Font.Height := -11;
    pnlDadosBanco.Font.Name := 'Tahoma';
    pnlDadosBanco.Font.Style := [fsBold];
    pnlDadosBanco.ParentFont := False;
    pnlDadosBanco.TabOrder := 15;
    pnlDadosBanco.Visible := False;
    pnlDadosSincronizacaoAutomatica.SetParentComponent(Self);
    pnlDadosSincronizacaoAutomatica.Name := 'pnlDadosSincronizacaoAutomatica';
    pnlDadosSincronizacaoAutomatica.Left := 8;
    pnlDadosSincronizacaoAutomatica.Top := 262;
    pnlDadosSincronizacaoAutomatica.Width := 461;
    pnlDadosSincronizacaoAutomatica.Height := 17;
    pnlDadosSincronizacaoAutomatica.Caption := 'Espa'#231'o Dados Sinc. Aut.';
    pnlDadosSincronizacaoAutomatica.ChildOrder := 23;
    pnlDadosSincronizacaoAutomatica.Color := clInfoText;
    pnlDadosSincronizacaoAutomatica.Font.Charset := DEFAULT_CHARSET;
    pnlDadosSincronizacaoAutomatica.Font.Color := clWhite;
    pnlDadosSincronizacaoAutomatica.Font.Height := -11;
    pnlDadosSincronizacaoAutomatica.Font.Name := 'Tahoma';
    pnlDadosSincronizacaoAutomatica.Font.Style := [fsBold];
    pnlDadosSincronizacaoAutomatica.ParentFont := False;
    pnlDadosSincronizacaoAutomatica.TabOrder := 16;
    pnlDadosSincronizacaoAutomatica.Visible := False;
    edsinc_aut_id.SetParentComponent(Self);
    edsinc_aut_id.Name := 'edsinc_aut_id';
    edsinc_aut_id.Left := 93;
    edsinc_aut_id.Top := 285;
    edsinc_aut_id.Width := 120;
    edsinc_aut_id.Height := 21;
    edsinc_aut_id.ChildOrder := 31;
    edsinc_aut_id.Enabled := False;
    edsinc_aut_id.HeightPercent := 100.000000000000000000;
    edsinc_aut_id.TabOrder := 6;
    edsinc_aut_id.Text := 'edsinc_aut_id';
    edsinc_aut_id.WidthPercent := 100.000000000000000000;
    edsinc_aut_id.DataField := 'banco_sinc.id';
    edsinc_aut_id.DataSource := DataSource;
    edsinc_aut_codigo_interno.SetParentComponent(Self);
    edsinc_aut_codigo_interno.Name := 'edsinc_aut_codigo_interno';
    edsinc_aut_codigo_interno.Left := 93;
    edsinc_aut_codigo_interno.Top := 312;
    edsinc_aut_codigo_interno.Width := 120;
    edsinc_aut_codigo_interno.Height := 21;
    edsinc_aut_codigo_interno.ChildOrder := 33;
    edsinc_aut_codigo_interno.Enabled := False;
    edsinc_aut_codigo_interno.HeightPercent := 100.000000000000000000;
    edsinc_aut_codigo_interno.TabOrder := 12;
    edsinc_aut_codigo_interno.Text := 'edsinc_aut_codigo_interno';
    edsinc_aut_codigo_interno.WidthPercent := 100.000000000000000000;
    edsinc_aut_codigo_interno.DataField := 'banco_sinc.codigo_interno';
    edsinc_aut_codigo_interno.DataSource := DataSource;
    edclient_id.SetParentComponent(Self);
    edclient_id.Name := 'edclient_id';
    edclient_id.Left := 93;
    edclient_id.Top := 339;
    edclient_id.Width := 120;
    edclient_id.Height := 21;
    edclient_id.ChildOrder := 31;
    edclient_id.Enabled := False;
    edclient_id.HeightPercent := 100.000000000000000000;
    edclient_id.TabOrder := 6;
    edclient_id.Text := 'edclient_id';
    edclient_id.WidthPercent := 100.000000000000000000;
    edclient_id.DataField := 'banco_sinc.client_id';
    edclient_id.DataSource := DataSource;
    edclient_secret.SetParentComponent(Self);
    edclient_secret.Name := 'edclient_secret';
    edclient_secret.Left := 93;
    edclient_secret.Top := 366;
    edclient_secret.Width := 120;
    edclient_secret.Height := 21;
    edclient_secret.ChildOrder := 31;
    edclient_secret.Enabled := False;
    edclient_secret.HeightPercent := 100.000000000000000000;
    edclient_secret.TabOrder := 6;
    edclient_secret.Text := 'edclient_secret';
    edclient_secret.WidthPercent := 100.000000000000000000;
    edclient_secret.DataField := 'banco_sinc.client_secret';
    edclient_secret.DataSource := DataSource;
    eddeveloper_key.SetParentComponent(Self);
    eddeveloper_key.Name := 'eddeveloper_key';
    eddeveloper_key.Left := 93;
    eddeveloper_key.Top := 393;
    eddeveloper_key.Width := 120;
    eddeveloper_key.Height := 21;
    eddeveloper_key.ChildOrder := 31;
    eddeveloper_key.Enabled := False;
    eddeveloper_key.HeightPercent := 100.000000000000000000;
    eddeveloper_key.TabOrder := 6;
    eddeveloper_key.Text := 'eddeveloper_key';
    eddeveloper_key.WidthPercent := 100.000000000000000000;
    eddeveloper_key.DataField := 'banco_sinc.developer_key';
    eddeveloper_key.DataSource := DataSource;
    cbxsinc_aut_excluido.SetParentComponent(Self);
    cbxsinc_aut_excluido.Name := 'cbxsinc_aut_excluido';
    cbxsinc_aut_excluido.Left := 349;
    cbxsinc_aut_excluido.Top := 285;
    cbxsinc_aut_excluido.Width := 120;
    cbxsinc_aut_excluido.Height := 22;
    cbxsinc_aut_excluido.Caption := 'cbxexcluido';
    cbxsinc_aut_excluido.ChildOrder := 33;
    cbxsinc_aut_excluido.Enabled := False;
    cbxsinc_aut_excluido.HeightPercent := 100.000000000000000000;
    cbxsinc_aut_excluido.WidthPercent := 100.000000000000000000;
    cbxsinc_aut_excluido.DataField := 'banco_sinc.excluido';
    cbxsinc_aut_excluido.DataSource := DataSource;
    edsinc_aut_inclusao.SetParentComponent(Self);
    edsinc_aut_inclusao.Name := 'edsinc_aut_inclusao';
    edsinc_aut_inclusao.Left := 349;
    edsinc_aut_inclusao.Top := 312;
    edsinc_aut_inclusao.Width := 120;
    edsinc_aut_inclusao.Height := 21;
    edsinc_aut_inclusao.ChildOrder := 43;
    edsinc_aut_inclusao.Enabled := False;
    edsinc_aut_inclusao.HeightPercent := 100.000000000000000000;
    edsinc_aut_inclusao.TabOrder := 14;
    edsinc_aut_inclusao.Text := 'edsinc_aut_inclusao';
    edsinc_aut_inclusao.WidthPercent := 100.000000000000000000;
    edsinc_aut_inclusao.DataField := 'banco_sinc.inclusao';
    edsinc_aut_inclusao.DataSource := DataSource;
    edsinc_aut_alteracao.SetParentComponent(Self);
    edsinc_aut_alteracao.Name := 'edsinc_aut_alteracao';
    edsinc_aut_alteracao.Left := 349;
    edsinc_aut_alteracao.Top := 339;
    edsinc_aut_alteracao.Width := 120;
    edsinc_aut_alteracao.Height := 21;
    edsinc_aut_alteracao.ChildOrder := 45;
    edsinc_aut_alteracao.Enabled := False;
    edsinc_aut_alteracao.HeightPercent := 100.000000000000000000;
    edsinc_aut_alteracao.TabOrder := 15;
    edsinc_aut_alteracao.Text := 'edsinc_aut_alteracao';
    edsinc_aut_alteracao.WidthPercent := 100.000000000000000000;
    edsinc_aut_alteracao.DataField := 'banco_sinc.alteracao';
    edsinc_aut_alteracao.DataSource := DataSource;
    edsinc_aut_exclusao.SetParentComponent(Self);
    edsinc_aut_exclusao.Name := 'edsinc_aut_exclusao';
    edsinc_aut_exclusao.Left := 349;
    edsinc_aut_exclusao.Top := 366;
    edsinc_aut_exclusao.Width := 120;
    edsinc_aut_exclusao.Height := 21;
    edsinc_aut_exclusao.ChildOrder := 46;
    edsinc_aut_exclusao.Enabled := False;
    edsinc_aut_exclusao.HeightPercent := 100.000000000000000000;
    edsinc_aut_exclusao.TabOrder := 16;
    edsinc_aut_exclusao.Text := 'edsinc_aut_exclusao';
    edsinc_aut_exclusao.WidthPercent := 100.000000000000000000;
    edsinc_aut_exclusao.DataField := 'banco_sinc.exclusao';
    edsinc_aut_exclusao.DataSource := DataSource;
    btnBaixarChavePrivada.SetParentComponent(Self);
    btnBaixarChavePrivada.Name := 'btnBaixarChavePrivada';
    btnBaixarChavePrivada.Left := 232;
    btnBaixarChavePrivada.Top := 388;
    btnBaixarChavePrivada.Width := 110;
    btnBaixarChavePrivada.Height := 25;
    btnBaixarChavePrivada.Caption := 'Baixar Chave Privada';
    btnBaixarChavePrivada.ChildOrder := 48;
    btnBaixarChavePrivada.HeightPercent := 100.000000000000000000;
    btnBaixarChavePrivada.TabOrder := 1;
    btnBaixarChavePrivada.WidthPercent := 100.000000000000000000;
    SetEvent(btnBaixarChavePrivada, Self, 'OnClick', 'btnBaixarChavePrivadaClick');
    btnBaixarCertificadoPem.SetParentComponent(Self);
    btnBaixarCertificadoPem.Name := 'btnBaixarCertificadoPem';
    btnBaixarCertificadoPem.Left := 350;
    btnBaixarCertificadoPem.Top := 388;
    btnBaixarCertificadoPem.Width := 119;
    btnBaixarCertificadoPem.Height := 25;
    btnBaixarCertificadoPem.Caption := 'Baixar Certificado PEM';
    btnBaixarCertificadoPem.ChildOrder := 49;
    btnBaixarCertificadoPem.HeightPercent := 100.000000000000000000;
    btnBaixarCertificadoPem.TabOrder := 1;
    btnBaixarCertificadoPem.WidthPercent := 100.000000000000000000;
    SetEvent(btnBaixarCertificadoPem, Self, 'OnClick', 'btnBaixarCertificadoPemClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := BancosDataset;
    DataSource.Left := 232;
    DataSource.Top := 208;
    BancosDataset.SetParentComponent(Self);
    BancosDataset.Name := 'BancosDataset';
    BancosDataset.AfterApplyUpdates := BancosDatasetAfterApplyUpdates;
    BancosDataset.EntitySetName := 'Bancos';
    BancosDataset.Connection := DMConnection.ApiConnection;
    BancosDataset.Left := 152;
    BancosDataset.Top := 208;
    BancosDatasetid.SetParentComponent(BancosDataset);
    BancosDatasetid.Name := 'BancosDatasetid';
    BancosDatasetid.FieldName := 'id';
    BancosDatasetid.Required := True;
    BancosDatasetnome.SetParentComponent(BancosDataset);
    BancosDatasetnome.Name := 'BancosDatasetnome';
    BancosDatasetnome.FieldName := 'nome';
    BancosDatasetnome.Required := True;
    BancosDatasetnome.Size := 255;
    BancosDatasetcodigo.SetParentComponent(BancosDataset);
    BancosDatasetcodigo.Name := 'BancosDatasetcodigo';
    BancosDatasetcodigo.FieldName := 'codigo';
    BancosDatasetcodigo.Size := 255;
    BancosDatasetdigital.SetParentComponent(BancosDataset);
    BancosDatasetdigital.Name := 'BancosDatasetdigital';
    BancosDatasetdigital.FieldName := 'digital';
    BancosDatasetdigital.Required := True;
    BancosDatasetcodigo_interno.SetParentComponent(BancosDataset);
    BancosDatasetcodigo_interno.Name := 'BancosDatasetcodigo_interno';
    BancosDatasetcodigo_interno.FieldName := 'codigo_interno';
    BancosDatasetcodigo_interno.Required := True;
    BancosDatasetexcluido.SetParentComponent(BancosDataset);
    BancosDatasetexcluido.Name := 'BancosDatasetexcluido';
    BancosDatasetexcluido.FieldName := 'excluido';
    BancosDatasetinclusao.SetParentComponent(BancosDataset);
    BancosDatasetinclusao.Name := 'BancosDatasetinclusao';
    BancosDatasetinclusao.FieldName := 'inclusao';
    BancosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetalteracao.SetParentComponent(BancosDataset);
    BancosDatasetalteracao.Name := 'BancosDatasetalteracao';
    BancosDatasetalteracao.FieldName := 'alteracao';
    BancosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetexclusao.SetParentComponent(BancosDataset);
    BancosDatasetexclusao.Name := 'BancosDatasetexclusao';
    BancosDatasetexclusao.FieldName := 'exclusao';
    BancosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetcodigo_cliente.SetParentComponent(BancosDataset);
    BancosDatasetcodigo_cliente.Name := 'BancosDatasetcodigo_cliente';
    BancosDatasetcodigo_cliente.FieldName := 'codigo_cliente';
    BancosDatasettoken.SetParentComponent(BancosDataset);
    BancosDatasettoken.Name := 'BancosDatasettoken';
    BancosDatasettoken.FieldName := 'token';
    BancosDatasettoken.Size := 255;
    BancosDatasetultima_sinc_ws.SetParentComponent(BancosDataset);
    BancosDatasetultima_sinc_ws.Name := 'BancosDatasetultima_sinc_ws';
    BancosDatasetultima_sinc_ws.FieldName := 'ultima_sinc_ws';
    BancosDatasetultima_sinc_ws.DisplayFormat := 'dd/mm/yy';
    BancosDatasetconsulta_sinc_ws.SetParentComponent(BancosDataset);
    BancosDatasetconsulta_sinc_ws.Name := 'BancosDatasetconsulta_sinc_ws';
    BancosDatasetconsulta_sinc_ws.FieldName := 'consulta_sinc_ws';
    BancosDatasetconsulta_sinc_ws.DisplayFormat := 'dd/mm/yy';
    BancosDatasetbanco_sinccodigo_interno.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sinccodigo_interno.Name := 'BancosDatasetbanco_sinccodigo_interno';
    BancosDatasetbanco_sinccodigo_interno.FieldName := 'banco_sinc.codigo_interno';
    BancosDatasetbanco_sincclient_id.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincclient_id.Name := 'BancosDatasetbanco_sincclient_id';
    BancosDatasetbanco_sincclient_id.FieldName := 'banco_sinc.client_id';
    BancosDatasetbanco_sincclient_secret.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincclient_secret.Name := 'BancosDatasetbanco_sincclient_secret';
    BancosDatasetbanco_sincclient_secret.FieldName := 'banco_sinc.client_secret';
    BancosDatasetbanco_sincdeveloper_key.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincdeveloper_key.Name := 'BancosDatasetbanco_sincdeveloper_key';
    BancosDatasetbanco_sincdeveloper_key.FieldName := 'banco_sinc.developer_key';
    BancosDatasetbanco_sincid.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincid.Name := 'BancosDatasetbanco_sincid';
    BancosDatasetbanco_sincid.FieldName := 'banco_sinc.id';
    BancosDatasetbanco_sincexcluido.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincexcluido.Name := 'BancosDatasetbanco_sincexcluido';
    BancosDatasetbanco_sincexcluido.FieldName := 'banco_sinc.excluido';
    BancosDatasetbanco_sincinclusao.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincinclusao.Name := 'BancosDatasetbanco_sincinclusao';
    BancosDatasetbanco_sincinclusao.FieldName := 'banco_sinc.inclusao';
    BancosDatasetbanco_sincinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetbanco_sincalteracao.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincalteracao.Name := 'BancosDatasetbanco_sincalteracao';
    BancosDatasetbanco_sincalteracao.FieldName := 'banco_sinc.alteracao';
    BancosDatasetbanco_sincalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetbanco_sincexclusao.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincexclusao.Name := 'BancosDatasetbanco_sincexclusao';
    BancosDatasetbanco_sincexclusao.FieldName := 'banco_sinc.exclusao';
    BancosDatasetbanco_sincexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetbanco_sincchave_privada_s3.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincchave_privada_s3.Name := 'BancosDatasetbanco_sincchave_privada_s3';
    BancosDatasetbanco_sincchave_privada_s3.FieldName := 'banco_sinc.chave_privada_s3';
    BancosDatasetbanco_sinccertificado_pem_s3.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sinccertificado_pem_s3.Name := 'BancosDatasetbanco_sinccertificado_pem_s3';
    BancosDatasetbanco_sinccertificado_pem_s3.FieldName := 'banco_sinc.certificado_pem_s3';
    XDataClientBancosGet.SetParentComponent(Self);
    XDataClientBancosGet.Name := 'XDataClientBancosGet';
    XDataClientBancosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientBancosGet, Self, 'OnLoad', 'XDataClientBancosGetLoad');
    XDataClientBancosGet.Left := 48;
    XDataClientBancosGet.Top := 208;
    XDataWebClientBaixarArquivos.SetParentComponent(Self);
    XDataWebClientBaixarArquivos.Name := 'XDataWebClientBaixarArquivos';
    XDataWebClientBaixarArquivos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientBaixarArquivos, Self, 'OnLoad', 'XDataWebClientBaixarArquivosLoad');
    SetEvent(XDataWebClientBaixarArquivos, Self, 'OnError', 'XDataWebClientBaixarArquivosError');
    XDataWebClientBaixarArquivos.Left := 104;
    XDataWebClientBaixarArquivos.Top := 448;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbcodigo.AfterLoadDFMValues;
    lbdigital.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbcodigo_cliente.AfterLoadDFMValues;
    lbtoken.AfterLoadDFMValues;
    lbultima_sinc_ws.AfterLoadDFMValues;
    lbconsulta_sinc_ws.AfterLoadDFMValues;
    lbsinc_aut_id.AfterLoadDFMValues;
    lbsinc_aut_codigo_interno.AfterLoadDFMValues;
    lbclient_id.AfterLoadDFMValues;
    lbclient_secret.AfterLoadDFMValues;
    lbdeveloper_key.AfterLoadDFMValues;
    lbsinc_aut_excluido.AfterLoadDFMValues;
    lbsinc_aut_inclusao.AfterLoadDFMValues;
    lbsinc_aut_alteracao.AfterLoadDFMValues;
    lbsinc_aut_exclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edcodigo.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    edcodigo_cliente.AfterLoadDFMValues;
    edtoken.AfterLoadDFMValues;
    edultima_sinc_ws.AfterLoadDFMValues;
    edconsulta_sinc_ws.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxdigital.AfterLoadDFMValues;
    btnCopiarToken.AfterLoadDFMValues;
    pnlDadosBanco.AfterLoadDFMValues;
    pnlDadosSincronizacaoAutomatica.AfterLoadDFMValues;
    edsinc_aut_id.AfterLoadDFMValues;
    edsinc_aut_codigo_interno.AfterLoadDFMValues;
    edclient_id.AfterLoadDFMValues;
    edclient_secret.AfterLoadDFMValues;
    eddeveloper_key.AfterLoadDFMValues;
    cbxsinc_aut_excluido.AfterLoadDFMValues;
    edsinc_aut_inclusao.AfterLoadDFMValues;
    edsinc_aut_alteracao.AfterLoadDFMValues;
    edsinc_aut_exclusao.AfterLoadDFMValues;
    btnBaixarChavePrivada.AfterLoadDFMValues;
    btnBaixarCertificadoPem.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    BancosDataset.AfterLoadDFMValues;
    BancosDatasetid.AfterLoadDFMValues;
    BancosDatasetnome.AfterLoadDFMValues;
    BancosDatasetcodigo.AfterLoadDFMValues;
    BancosDatasetdigital.AfterLoadDFMValues;
    BancosDatasetcodigo_interno.AfterLoadDFMValues;
    BancosDatasetexcluido.AfterLoadDFMValues;
    BancosDatasetinclusao.AfterLoadDFMValues;
    BancosDatasetalteracao.AfterLoadDFMValues;
    BancosDatasetexclusao.AfterLoadDFMValues;
    BancosDatasetcodigo_cliente.AfterLoadDFMValues;
    BancosDatasettoken.AfterLoadDFMValues;
    BancosDatasetultima_sinc_ws.AfterLoadDFMValues;
    BancosDatasetconsulta_sinc_ws.AfterLoadDFMValues;
    BancosDatasetbanco_sinccodigo_interno.AfterLoadDFMValues;
    BancosDatasetbanco_sincclient_id.AfterLoadDFMValues;
    BancosDatasetbanco_sincclient_secret.AfterLoadDFMValues;
    BancosDatasetbanco_sincdeveloper_key.AfterLoadDFMValues;
    BancosDatasetbanco_sincid.AfterLoadDFMValues;
    BancosDatasetbanco_sincexcluido.AfterLoadDFMValues;
    BancosDatasetbanco_sincinclusao.AfterLoadDFMValues;
    BancosDatasetbanco_sincalteracao.AfterLoadDFMValues;
    BancosDatasetbanco_sincexclusao.AfterLoadDFMValues;
    BancosDatasetbanco_sincchave_privada_s3.AfterLoadDFMValues;
    BancosDatasetbanco_sinccertificado_pem_s3.AfterLoadDFMValues;
    XDataClientBancosGet.AfterLoadDFMValues;
    XDataWebClientBaixarArquivos.AfterLoadDFMValues;
  end;
end;

end.
